import i18n from '~/locales/i18next';

export const ADMIN_ROLES = {
  USERS_LIST_CSV: 21,
  ACCOUNT_MANAGEMENT_ROLE: 1,
} as const;
export type AdminRoles = (typeof ADMIN_ROLES)[keyof typeof ADMIN_ROLES];

export const USER_CATEGORY = {
  INDIVIDUAL: 1,
  CORPORATE: 2,
} as const;
export type UserCategory = (typeof USER_CATEGORY)[keyof typeof USER_CATEGORY];

export const INDIVIDUAL_CATEGORY = {
  INDIVIDUAL: 1,
  UNIVERSITY_STUDENT: 2,
  SOLO_PROPRIETORSHIP: 3,
  LABORATORY: 4,
  CORPORATE: 0,
} as const;

export const INDIVIDUAL_CATEGORY_NAME = {
  [INDIVIDUAL_CATEGORY.INDIVIDUAL]: i18n.t('registration.user.individualCategory.1'),
  [INDIVIDUAL_CATEGORY.UNIVERSITY_STUDENT]: i18n.t('registration.user.individualCategory.2'),
  [INDIVIDUAL_CATEGORY.SOLO_PROPRIETORSHIP]: i18n.t('registration.user.individualCategory.3'),
  [INDIVIDUAL_CATEGORY.LABORATORY]: i18n.t('registration.user.individualCategory.4'),
  [INDIVIDUAL_CATEGORY.CORPORATE]: i18n.t('registration.user.individualCategory.0'),
} as const;
export type IndividualUserCategory = (typeof INDIVIDUAL_CATEGORY)[keyof typeof INDIVIDUAL_CATEGORY];

export const JUDGEMENT_STATUS = {
  UNTOUCHED: 1,
  OK: 2,
  NG: 3,
  UNNEEDED: 4,
} as const;
export type JudgementStatus = (typeof JUDGEMENT_STATUS)[keyof typeof JUDGEMENT_STATUS];

export const SURVEY_STATUSES = {
  REGISTERING: 1,
  UNDER_REVIEW: 2,
  APPROVED: 3,
  COLLECTING: 4,
  COMPLETED: 6,
  REJECTED: 7,
  CANCELED: 8,
} as const;

export type SurveyStatus = (typeof SURVEY_STATUSES)[keyof typeof SURVEY_STATUSES];

export const SURVEY_FORM_TYPE = {
  GOOGLE_FORM: 1,
  ORIGINAL_FORM: 2,
} as const;
export type SurveyFormType = (typeof SURVEY_FORM_TYPE)[keyof typeof SURVEY_FORM_TYPE];

export const QUESTION_TYPE_ID = {
  SINGLE_ANSWER: 11,
  SINGLE_ANSWER_PULLDOWN: 12,
  MULTIPLE_ANSWER: 21,
  FREE_ANSWER_SHORT: 31,
  FREE_ANSWER_LONG: 32,
  FREE_ANSWER_NUMERIC: 33,
  TEXT: 41,
} as const;
export type QuestionType = (typeof QUESTION_TYPE_ID)[keyof typeof QUESTION_TYPE_ID];

export const QUESTION_TYPE_LABEL = {
  [QUESTION_TYPE_ID.MULTIPLE_ANSWER]: i18n.t('webAggregation.questionTypeLabel.multipleAnswer'),
  [QUESTION_TYPE_ID.SINGLE_ANSWER]: i18n.t('webAggregation.questionTypeLabel.singleAnswer'),
  [QUESTION_TYPE_ID.FREE_ANSWER_NUMERIC]: i18n.t('webAggregation.questionTypeLabel.numAnswer'),
} as const;

export const CONTENT_TYPE = {
  QUESTION_BOX: 1,
  DESCRIPTION_BOX: 2,
  PAGE_BREAK: 3,
} as const;
export type ContentType = (typeof CONTENT_TYPE)[keyof typeof CONTENT_TYPE];

export const QUESTION_CONFIG_TYPE = {
  REQUIRED: 'required',
  RANDOM: 'random',
  GOTO_REQUIRED: 'gotoRequired',
} as const;
export type QuestionConfigType = (typeof QUESTION_CONFIG_TYPE)[keyof typeof QUESTION_CONFIG_TYPE];

export const ANSWER_CONFIG_TYPE = {
  NEW: 'new',
  OTHER_REQUIRED: 'otherRequired',
  EXCLUSIVE_REQUIRED: 'exclusiveRequired',
} as const;
export type AnswerConfigType = (typeof ANSWER_CONFIG_TYPE)[keyof typeof ANSWER_CONFIG_TYPE];

export const ORIGINAL_FORM_LABEL_STYLES = {
  BOLD: 'BOLD',
  ITALIC: 'ITALIC',
  UNDERLINE: 'UNDERLINE',
};
export type OriginalFormLabelStylesType =
  (typeof ORIGINAL_FORM_LABEL_STYLES)[keyof typeof ORIGINAL_FORM_LABEL_STYLES];

export const SUMMARY_DATA_TYPE = {
  GT_TABLE: 1,
  DATA_MAP_RAW: 2,
  LABEL_EXPORT: 3,
} as const;
export type SummaryDataType = (typeof SUMMARY_DATA_TYPE)[keyof typeof SUMMARY_DATA_TYPE];

export const ORIGINAL_FORM_VALIDATION = {
  SECTION_MAX_SIZE: 50,
  QUESTION_MAX_SIZE: 10,
  QUESTION_MIN_SIZE: 1,
  QUESTION_LABEL_MAX_SIZE: 500,
  ANSWER_MAX_SIZE: 20,
  ANSWER_MIN_SIZE: 1,
  ANSWER_LABEL_MAX_SIZE: 255,
  ALL_QUESTION_MAX_SIZE: 99,
  MAX_QUESTION_IMG: 10,
};

export const SURVEY_REGISTER_TAB = {
  REGISTER: 0,
  REGISTER_PAST: 2,
} as const;

export const USER_INQUIRY = {
  REQUEST_PARAM: 'from',
  SUBJECT_MAXLENGTH: 50,
  MESSAGE_MAXLENGTH: 3000,
};
export type UserInquiryType = (typeof USER_INQUIRY)[keyof typeof USER_INQUIRY];
